import axios from 'axios'
import {
  instagramRedirectUrl,
  instagramClientID
} from '../../config/constant'
export const instaStatusCheck = (methodType) => {
  let index = -1,callCount=0;
  let instaAccessToken = localStorage.getItem("instaAccessToken");
  if (!instaAccessToken) {
    let url = `https://api.instagram.com/oauth/authorize/?client_id=${instagramClientID}&redirect_uri=${instagramRedirectUrl}&response_type=token`
    let childWindow = window.open(url, "_blank", false);
    if (window.cordova) {
      childWindow.addEventListener(
        'loadstart',
        (event) => {
          console.log("loadstart event", event.url);
          if (event.url.indexOf('access_token') > 0 ||
            event.url.indexOf('error=') > 0) {
            instaAccessToken = checkForToken(event, event.url);
            childWindow.close();
            fetchInstaData(instaAccessToken);
          }
        }
      )
    } else {
      try{
        if (window.chrome) {
          let count = 0, chUrl;
          let clearIn = setInterval(() => {
            try {
              callCount++;
              if (callCount > 300) {
                window.clearInterval(clearIn);
              }
            if (childWindow.location.origin) {
              chUrl = childWindow.location.href
              count++;
              if (chUrl) {
                index = chUrl.indexOf('access_token');
              }
              if (count > 300 || index > 0) {
                window.clearInterval(clearIn);
                //instaAccessToken = checkForToken(null, chUrl);
                childWindow.close();
                //fetchInstaData(instaAccessToken);
              }
              console.log("interval", count, index, childWindow.location.href)
            }
          } catch(e) {
            console.log(e)
          }
          }, 50);
        }
        else {
          childWindow.addEventListener(
            'popstate',
            (event) => {
              index = childWindow.location.href.indexOf('access_token');
              console.log("popstate event", childWindow.location.href);
              if (index > 0 ||
                childWindow.location.href.indexOf('error=') > 0) {
                instaAccessToken = checkForToken(event, childWindow.location.href);
                fetchInstaData(instaAccessToken);
                childWindow.close();
              }
            }
          )
        }
      } catch (e) {
        console.log("error while instagram Oauth", e);
      }
    }
  } else {
    console.log("token is in the local store");
  }
  if (methodType === "post") {

  }
}

const fetchInstaData = (instaAccessToken) => {
  let guestInstaProfile = localStorage.getItem("guestInstaProfile");
  if (!guestInstaProfile) {
    if (instaAccessToken && instaAccessToken !== "unoauth") {
      profileAPI(instaAccessToken);
      console.log("guestInstaProfile data is not in localstore");
    } else {
      console.log("user permission denied")
    }
  } else {
    console.log("guestInstaProfile data is in localstore no need to fetch");
  }
}

async function profileAPI(instaAccessToken) {
  let data = {}
  data = await axios.get(
    `https://api.instagram.com/v1/users/self/?access_token=${instaAccessToken}`
  )
    .catch(
      ({ response = {} }) => {
        console.log("Api failed with the status code:", response.status);
      }
    )
  console.log("data.data", data);
  if (data) {
    data = JSON.stringify(data.data);
    localStorage.setItem("guestInstaProfile", data);
  } else {
    console.log("instagram profile response without data", data);
  }
}

const checkForToken = (event, url) => {
  let index, accessToken = "unoauth";
  if (url) {
    index = url.indexOf('access_token');
    if (index !== -1) {
      index = index + 13;
      accessToken = url.substr(index);
      localStorage.setItem("instaAccessToken", accessToken);
      console.log("access_token is--------", accessToken);
    } else if (url.indexOf('error=') > 0) {
      console.log("problem in API url", url);
    } else {
      console.log("user not give permission to access instagram the data");
    }
  }
  return accessToken;
}

export const logout = () => {
  localStorage.setItem("guestInstaProfile", "");
  localStorage.setItem("instaAccessToken", "");
}